/**
 * Tracks newsletter subscribers by adding a dataLayer event
 */
const initSubscriberTracking = () => {
  // If tracking is not enabled return
  if (window.theme.tracking.subscriberTracking.enabled !== true) {
    return;
  }

  window.dataLayer = window.dataLayer || [];

  // Add Klaviyo submit event listened
  window.addEventListener('klaviyoForms', event => {
    if (event.detail.type !== 'submit') {
      return;
    }
    window.dataLayer.push({
      event: 'newsletterSubscription',
      details: {
        formType: 'klaviyo',
        formID: event.detail.formId,
      },
    });
  });

  // If the Shopify subscribe form has successfully been submitted
  const formID = window.theme.tracking.subscriberTracking.successfullySubscribed;
  if (formID) {
    const alreadySentSubscribeEvent = sessionStorage.getItem('alreadySentSubscribeEvent')
      ? JSON.parse(sessionStorage.getItem('alreadySentSubscribeEvent'))
      : [];

    // If we have already sent this event return
    if (alreadySentSubscribeEvent.includes(formID)) {
      return;
    }

    alreadySentSubscribeEvent.push(formID);
    sessionStorage.setItem('alreadySentSubscribeEvent', JSON.stringify(alreadySentSubscribeEvent));

    window.dataLayer.push({
      event: 'newsletterSubscription',
      details: {
        formType: 'shopify',
        formID,
      },
    });
  }
};

export default initSubscriberTracking;
